module.exports = __webpack_public_path__ + "img/ig.2fa21f6f.svg";